module.exports = __webpack_public_path__ + "resources/img/bg_cover_solution_m_v2.081b17efd16f0e7d60a8801973e0eddb.png";